import React from 'react'

export function DisplaySuccessMessage({ errorInsertUserPlan }) {
    return (
        <>
            {errorInsertUserPlan !== null ? (
                <div class="alert alert-secondary" role="alert">
                    <ul>
                        {errorInsertUserPlan !== null ? (
                            <li
                                style={{
                                    paddingTop: 10,
                                    color: errorInsertUserPlan.type === 'error' ? 'red' : '#66bb6a',
                                    fontWeight: 'bold',
                                }}
                            >
                                {errorInsertUserPlan.value}
                            </li>
                        ) : (
                            ''
                        )}
                    </ul>
                </div>
            ) : (
                ''
            )}
        </>
    )
}
